import React, { useState, useEffect, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import SideModal from "../../Components/SideModal";
import Table from "../../Components/Inventory/Kitchen/Table";
import AddKitchen from "../../Components/Inventory/Kitchen/AddKitchen";
import { Form, Formik } from "formik";
import EditKitchen from "../../Components/Inventory/Kitchen/EditKitchen";
import DeleteKitchen from "../../Components/Inventory/Kitchen/DeleteKitchen";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";

const KitchenList = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const properties = useSelector((state) => state.PropertyReducer.property);
    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const [isShowAddKitchen, setIsShowAddKitchen] = useState(false);
    const [isShowEditKitchen, setIsShowEditKitchen] = useState(false);
    const [isDeleteKitchen, setIsDeleteKitchen] = useState(false);
    const user = useSelector((state) => state.UserReducer.user);
    const [apiData, setApiData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("");

    const searchOptions = [
        { label: "Kitchen", value: 1 },
        // { label: "Kitchen", value: 2 },
    ];
    const [selectedData, setSelectedData] = useState("");
    const [selectedProperty, setSelectedProperty] = useState(property);

    const panelRef = useRef(null);
    const btnRef = useRef(null);

    // Fetch items
    const fetchFunction = async () => {
        const params = new URLSearchParams();

        if (searchQuery) {
            params.append("s", searchQuery);
            if (filterType) {
                params.append("t", filterType);
            }
        }
        if (selectedProperty?.id) {
            params.append("propIds", selectedProperty?.id);

        }

        const response = await axios.get(
            `${Config.apiUrl}/kitchen/list/kitchen?${params.toString()}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess === false) {
            toast.error(res.msg || "Failed to fetch kitchen items");
        } else {
            const kitchens = res.kitchens || [];
            setApiData(kitchens);
        }
    };

    const getError = () => {
        navigate("/no-access");
    };

    const {
        isLoading: isFetching,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getListMutate();
        }, 200);
        return () => clearTimeout(handler);
    }, [searchQuery, filterType, selectedProperty?.id,]);

    // Handle search
    const handleFilterChange = (values) => {
        setSearchQuery(values.searchQuery || "");
        setFilterType(values.filterType || "");
    };

    // Handle date range submit
    const submitHandler = (values) => {
        setFilterType("");
        setSearchQuery("");
    };

    // Clear all filters
    const handleClearFilters = () => {
        setSearchQuery("");
        setFilterType("");
    };

    //------- Add Kitchen -------
    const addKitchenFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/kitchen/add/kitchen`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Content-Type": "application/json",
            },
        });
    };

    const onAddKitchenSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            getListMutate();
            setIsShowAddKitchen(false);
        } else {
            //   setIsShowAddTransfer(false);
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onAddKitchenError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addKitchenLoading, mutate: addKitchenMutate } = useMutation(
        addKitchenFunction,
        {
            onSuccess: onAddKitchenSuccess,
            onError: onAddKitchenError,
        }
    );

    //------- Edit Kitchen -------
    const editKitchenFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/kitchen/edit/kitchen`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Content-Type": "application/json",
            },
        });
    };

    const onEditKitchenSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            getListMutate();
            setIsShowEditKitchen(false);
        } else {
            //   setIsShowAddTransfer(false);
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onEditKitchenError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editKitchenLoading, mutate: editKitchenMutate } = useMutation(
        editKitchenFunction,
        {
            onSuccess: onEditKitchenSuccess,
            onError: onEditKitchenError,
        }
    );

    //------- Delete Kitchen -------
    const deleteKitchenFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/kitchen/delete/kitchen`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const onDeleteKitchenSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            getListMutate();
            setIsDeleteKitchen(false);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onDeleteKitchenError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: deleteKitchenLoading, mutate: deleteKitchenMutate } =
        useMutation(deleteKitchenFunction, {
            onSuccess: onDeleteKitchenSuccess,
            onError: onDeleteKitchenError,
        });

    const handlePropertySelect = (property) => {
        setSelectedProperty(property);
        handleClearFilters()
    };

    return (
        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    Kitchen List
                    <Underline />
                </BoxTitle>
                <Filters
                    setIsShowAddKitchen={setIsShowAddKitchen}
                />
            </BoxHead>


            <FilterTableWrapper>
                <FilterWrapperWithSearch>
                    <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                        <div className="flex items-center">
                            <Text>
                                Total kitchens:{" "}
                                <span className="font-semibold">
                                    {apiData?.length || 0}
                                </span>
                            </Text>
                        </div>

                    </div>
                    <div className="flex md:gap-0 gap-4 md:space-x-4 md:flex-row flex-col justify-end items-center">
                        <SearchFilterBox
                            options={searchOptions}
                            handleFilterChange={handleFilterChange}
                            handleClearFilters={handleClearFilters}
                            className="flex-1 min-w-0"
                        />
                        <PropertiesFilterDropdown
                            properties={properties}
                            selectedProperty={selectedProperty}
                            onPropertySelect={handlePropertySelect}
                            placeholder="Select Property"
                            className="min-w-[200px] w-full md:w-[220px]"
                        />
                    </div>
                </FilterWrapperWithSearch>

                <SideModal
                    isOpen={isShowAddKitchen}
                    onClose={() => setIsShowAddKitchen(false)}
                >
                    <AddKitchen
                        handleClose={() => setIsShowAddKitchen(false)}
                        addKitchenMutate={addKitchenMutate}
                        addKitchenLoading={addKitchenLoading}
                        setIsShowAddKitchen={setIsShowAddKitchen}
                    />
                </SideModal>
                <SideModal
                    isOpen={isShowEditKitchen}
                    onClose={() => setIsShowEditKitchen(false)}
                >
                    <EditKitchen
                        handleClose={() => setIsShowEditKitchen(false)}
                        editKitchenMutate={editKitchenMutate}
                        editKitchenLoading={editKitchenLoading}
                        setIsShowEditKitchen={setIsShowEditKitchen}
                        selectedData={selectedData}
                    />
                </SideModal>

                {isDeleteKitchen && (
                    <DeleteKitchen
                        selectedData={selectedData}
                        setIsDeleteKitchen={setIsDeleteKitchen}
                        deleteKitchenMutate={deleteKitchenMutate}
                        deleteKitchenLoading={deleteKitchenLoading}
                    />
                )}

                {!error && !isFetching && data && (
                    <TableWrapper>
                        <Table
                            apiData={error ? [] : apiData}
                            selectedData={selectedData}
                            setSelectedData={setSelectedData}
                            setIsShowEditKitchen={setIsShowEditKitchen}
                            setIsDeleteKitchen={setIsDeleteKitchen}
                        />
                        {(error || apiData.length === 0) && !isFetching && (
                            <NotFoundModel msg={"No kitchens found."} />
                        )}
                    </TableWrapper>
                )}
            </FilterTableWrapper>

            {(isFetching || isRefetching) && <Loading />}
        </BoxContainer>
    );
};
const Filters = ({
    setIsShowAddKitchen,
}) => {
    return (
        <Formik >
            <Form>
                <FilterContainer>
                    <AddBtn
                        type="button"
                        onClick={() => {
                            setIsShowAddKitchen(true);
                        }}
                    >
                        {"Add Kitchen"}
                    </AddBtn>
                </FilterContainer>
            </Form>
        </Formik>
    );
};
const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
const AddBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 lg:gap-0 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const Text = tw.p`text-gray-500 text-sm font-normal`;

export default KitchenList;